"use client";

import { cn } from "@/lib/utils";

type RichTextProps = {
  html?: string | null;
  className?: string;
};

export function RichText({ html, className }: RichTextProps) {
  if (!html) return null;
  return (
    <div
      className={cn("prose prose-sm max-w-none rich-text-content", className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
